import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import RelatedLinks from '../RelatedLinks';
import TradeZakatTable from './TradeZakatTable';
import { SERVER_URL } from '../ConstantsEN';
import { Trade_Zakat_EndPoint } from '../ConstantsEN';
import { CalculatorsType } from '../ConstantsEN';
import SharedHelmet from "../Helmet";
const TITLE = 'Trade Property Zakat Calculator - Calculate Your Trade Property Zakat Accurately';
const DESCRIPTION = 'The Trade Property Zakat Calculator is a calculation tool designed to facilitate the calculation of the amount of Zakat due on trade property in accordance with Islamic principles. The calculator aims to provide a quick and accurate solution for individuals and traders who want to determine the Zakat amount due according to established Sharia standards.';
const KEYWORDS = 'Trade Property Zakat, Calculate Trade Property Zakat';
const OG_URL = 'https://do-calculate.com/calculator/en/trade-zakat/';
const apiEndpoint = `${SERVER_URL}/${Trade_Zakat_EndPoint}`;
function TradeZakatCalculator() {
    const [cash, setCash] = useState(0);
    const [yearType, setYearType] = useState('');
    const [gramPriceGold, setGramPriceGold] = useState(0);
    const [gramPriceSilver, setGramPriceSilver] = useState(0);
    const [debtsReceivable, setDebtsReceivable] = useState(0);
    const [debtsPayable, setDebtsPayable] = useState(0);
    const [merchandise, setMerchandise] = useState(0);
    const [result, setRestul] = useState(null);
    const [statusCode, setStatusCode] = useState(null);
    const [thresholdType, setThresholdType] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const handleThresholdTypeChange = (event) => {
        const newThresholdType = event.target.value;
        setThresholdType(newThresholdType);
        if (newThresholdType === "gold") {
            setGramPriceSilver(0);
        } else if (newThresholdType === "silver") {
            setGramPriceGold(0);
        }
    };
    const handleYearTypeChange = (event) => {
        setYearType(event.target.value);
    };
    const handleCashChange = (event) => {
        setCash(event.target.value);
    };
    const handleDebtsReceivableChange = (event) => {
        setDebtsReceivable(event.target.value);
    };
    const handleMerchandiseChange = (event) => {
        setMerchandise(event.target.value);
    };
    const handleDebtsPayableChange = (event) => {
        setDebtsPayable(event.target.value);
    };
    const handleGramPriceGoldChange = (event) => {
        setGramPriceGold(event.target.value);
    };
    const handleGramPriceSilverChange = (event) => {
        setGramPriceSilver(event.target.value);
    };
    const calculateTradeZakat = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ merchandise, cash, debtsReceivable, debtsPayable, yearType, gramPriceGold, gramPriceSilver }),
            });
            const data = await response.json();
            setStatusCode(response.status);
            if (response.ok) {
                setRestul(data.result);
            } else {
                setRestul(null);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div>
              <SharedHelmet
             TITLE={TITLE}
             DESCRIPTION={DESCRIPTION}
             KEYWORDS={KEYWORDS}
             OG_URL={OG_URL}
           />
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '15px' }}>Calculate Trade Property Zakat</h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                The Trade Property Zakat Calculator is a calculation tool designed to facilitate the calculation of the amount of Zakat due on trade property in accordance with Islamic principles. The calculator aims to provide a quick and accurate solution for individuals and traders who want to determine the Zakat amount due according to established Sharia standards.
                                <br />
                                <hr />
                            </div>
                            <br />
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-5 calculatorStyle">
                                <div className='p-3 mb-2 bg-success text-white'>
                                    Trade Property Zakat
                                </div>
                                <hr />
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='yearType' >Year Type</label>
                                    </b>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="yearType"
                                            value="gregorian"
                                            id="gregorian"
                                            checked={yearType === "gregorian"}
                                            onChange={handleYearTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="gregorian">
                                            Gregorian
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="yearType"
                                            id="hijri"
                                            value="hijri"
                                            checked={yearType === "hijri"}
                                            onChange={handleYearTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="hijri">
                                            Hijri
                                        </label>
                                    </div>
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='merchandiseNumber' className="form-label ms-2">Trade Property</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="merchandiseNumber"
                                        value={merchandise}
                                        onChange={handleMerchandiseChange}
                                        className="form-control ml-2"
                                        style={{ width: '90%' }}
                                    />
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='cashNumber' className="form-label ms-2">Total Cash</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="cashNumber"
                                        value={cash}
                                        onChange={handleCashChange}
                                        className="form-control ml-2"
                                        style={{ width: '90%' }}
                                    />
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='debtsReceivableNumber' className="form-label ms-2">Debts Receivable</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="debtsReceivableNumber"
                                        value={debtsReceivable}
                                        onChange={handleDebtsReceivableChange}
                                        className="form-control ml-2"
                                        style={{ width: '90%' }}
                                    />
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='debtsPayableNumber' className="form-label ms-2">Debts Payable</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="debtsPayableNumber"
                                        value={debtsPayable}
                                        onChange={handleDebtsPayableChange}
                                        className="form-control ml-2"
                                        style={{ width: '90%' }}
                                    />
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label  >Threshold Type</label>
                                    </b>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="thresholdType"
                                            value="gold"
                                            id="gold"
                                            checked={thresholdType === "gold"}
                                            onChange={handleThresholdTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="gold">
                                            Gold
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="thresholdType"
                                            value="silver"
                                            id="silver"
                                            checked={thresholdType === "silver"}
                                            onChange={handleThresholdTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="silver">
                                            Silver
                                        </label>
                                    </div>
                                </div>
                                <br />
                                {thresholdType === "gold" && (
                                    <div className="form-group d-flex align-items-center">
                                        {gramPriceSilver === 0}
                                        <b>
                                            <label htmlFor='gramPriceGoldNumber' className="form-label ms-2">Gold Gram Price (24 Karat)</label>
                                        </b>
                                        <input
                                            type="number"
                                            id="gramPriceGoldNumber"
                                            value={gramPriceGold}
                                            onChange={handleGramPriceGoldChange}
                                            className="form-control ml-2"
                                            style={{ width: '90%' }}
                                        />
                                    </div>
                                )}
                                {thresholdType === "silver" && (
                                    <div className="form-group d-flex align-items-center">
                                        {gramPriceGold === 0}
                                        <b>
                                            <label htmlFor='gramPriceSilverNumber' className="form-label ms-2">Silver Gram Price (99.9 Purity)</label>
                                        </b>
                                        <input
                                            type="number"
                                            id="gramPriceSilverNumber"
                                            value={gramPriceSilver}
                                            onChange={handleGramPriceSilverChange}
                                            className="form-control ml-2"
                                            style={{ width: '75px' }}
                                        />
                                    </div>
                                )}
                                <br/>                                <hr />
                                <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={calculateTradeZakat} disabled={isLoading}>
                                    {isLoading ? (
                                        <div className="spinner-border spinner-border-sm" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    ) : (
                                        'Calculate'
                                    )}
                                </button>
                            </div>
                            <div className="col-sm-12 col-md-7">
                                <br />
                                {statusCode === 400 && <div className="alert alert-warning"><b><u>Error:</u></b> Please enter all fields correctly. </div>}
                                {result && (
                                    <div>
                                        <h4><div className="p-3 mb-2 bg-success text-white">Results: </div></h4>
                                        <hr />
                                        <TradeZakatTable result={result}></TradeZakatTable>
                                    </div>
                                )}
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col" >
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.islamicCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">Description of Trade Zakat Calculator</div>
                            <div className="info-section-body">
                                <u><b>Trade Zakat Calculator</b></u> <br/>                                The Trade Zakat calculator is a tool used to calculate the amount of Zakat due on trade assets. The calculator is developed to take into account owned goods, cash, debts owed to traders, debts owed by traders, the type of calendar (Hijri or Gregorian), and gold and silver prices to calculate the minimum amount eligible for Zakat. The calculator is based on specific Islamic rules for calculating the Zakat amount as a specific percentage of the asset's value.
                                <br/>                                The Trade Zakat calculator includes several components and criteria to calculate Zakat correctly. The basic data entered into the calculator includes:
                                <ul>
                                    <li>Owned Goods: The value of trade goods owned by the trader during a specified period, including stored, sold, and purchased goods.</li>
                                    <li>Cash: The value of cash assets owned by the trader in bank accounts or available for payment.</li>
                                    <li>Debts Owed to Traders: Amounts owed to traders and suppliers that have not been paid yet.</li>
                                    <li>Debts Owed by Traders: Amounts owed by customers and buyers that have not been received yet.</li>
                                    <li>Type of Calendar: The calendar type used for Zakat calculation, whether it is Hijri or Gregorian.</li>
                                    <li>Gold and Silver Prices: Current gold and silver prices are used to calculate the minimum amount eligible for Zakat. This is based on the standard weight of gold and silver and their value per unit weight.</li>
                                </ul>
                                <br/>                                After entering this data, the calculator converts it into numbers and calculates the minimum amount eligible for Zakat based on the provided gold and silver prices. Then, Zakat is calculated as a specific percentage of the calculated asset value according to Islamic rules. The calculator presents the calculated results clearly, such as the Zakat amount due, eligible assets, and the calculated minimum threshold.
                                <br/>                                The Trade Zakat calculator allows individuals and traders to easily and quickly calculate Zakat, helping them comply with Islamic principles and necessary rules for Zakat payment. The calculator can be used in smartphone applications, websites, or specialized software for trade Zakat calculation, providing convenience and accuracy in the Zakat calculation process and promoting compliance with Islamic requirements.
                                <br />
                                <hr />
                                <b>Last Reviewed On: </b>
                                07/07/2023
                            </div>
                        </div>
                    </div>
                </div>
            </div> <br />
        </div>
    );
}
export default TradeZakatCalculator;
